export * from './tags';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/tags/index.js
// module id = 878
// module chunks = 3